import React from 'react'
import style from './loading.module.scss'
import { PropTypes } from 'prop-types'
import VegaColors from '../../../resources/constants/colors.module.scss'

const VegaLoading = ({
	size = 24,
	color = VegaColors.SECONDARYINVERTED,
	background = '#FFFDF6'
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 60 60"
			className={style.loading}
		>
			<g clip-path="url(#clip0_10976_65782)">
				<path
					d="M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30ZM7.5 30C7.5 42.4264 17.5736 52.5 30 52.5C42.4264 52.5 52.5 42.4264 52.5 30C52.5 17.5736 42.4264 7.5 30 7.5C17.5736 7.5 7.5 17.5736 7.5 30Z"
					fill="#140309"
				/>
				<path
					d="M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30ZM7.5 30C7.5 42.4264 17.5736 52.5 30 52.5C42.4264 52.5 52.5 42.4264 52.5 30C52.5 17.5736 42.4264 7.5 30 7.5C17.5736 7.5 7.5 17.5736 7.5 30Z"
					fill={background}
					fill-opacity="0.25"
				/>
				<path
					d="M26.1189 4.0385C25.8127 1.99019 27.2278 0.0566432 29.2983 0.00820258C32.7534 -0.0726322 36.2062 0.443999 39.5022 1.54462C43.9874 3.04238 48.055 5.57919 51.3733 8.94812C54.6916 12.317 57.1665 16.4227 58.5961 20.9301C59.6466 24.2423 60.1109 27.7026 59.9777 31.1561C59.8979 33.2256 57.9432 34.6112 55.8997 34.274C53.8563 33.9368 52.5064 32.0008 52.4999 29.9298C52.4928 27.6525 52.1399 25.3821 51.4471 23.1975C50.3748 19.817 48.5187 16.7378 46.03 14.2111C43.5413 11.6844 40.4906 9.78179 37.1266 8.65847C34.9528 7.93257 32.6881 7.54537 30.4111 7.50375C28.3404 7.46591 26.4251 6.0868 26.1189 4.0385Z"
					fill="#FFFDF6"
				/>
			</g>
			<defs>
				<clipPath id="clip0_10976_65782">
					<rect width="60" height="60" fill={color} />
				</clipPath>
			</defs>
		</svg>
	)
}

VegaLoading.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Size on the component */
	size: PropTypes.number,
	/** Color of the spinner */
	color: PropTypes.string,
	/** Background of the spinner */
	background: PropTypes.string
}

export { VegaLoading }
